import { TofeCustomization } from './models/tofe-customization.model';

export const DefaultCustomization: TofeCustomization = {
  name: 'default',
  //default is defined in the variable.scss
  cssVariables: {},
};
